import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = {
  key: 0,
  class: "bg-red-50 border-2 border-red-500 rounded-lg p-5"
}
const _hoisted_3 = { class: "mb-4 flex items-center justify-between gap-3" }
const _hoisted_4 = { class: "font-bold text-red-900" }
const _hoisted_5 = { class: "flex shrink-0 rounded border border-red-400 bg-white p-1 text-xs" }
const _hoisted_6 = {
  key: 0,
  class: "space-y-3 text-sm text-red-900"
}
const _hoisted_7 = {
  key: 1,
  class: "space-y-3 text-sm text-red-900"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-2"
}
const _hoisted_10 = {
  key: 3,
  class: "mt-4 font-semibold text-green-700"
}
const _hoisted_11 = {
  key: 1,
  class: "bg-red-50 border border-red-200 rounded-lg p-4"
}
const _hoisted_12 = {
  key: 2,
  class: "bg-yellow-50 border border-yellow-200 rounded-lg p-4"
}
const _hoisted_13 = { class: "text-sm font-semibold text-red-600 mb-3" }
const _hoisted_14 = {
  key: 4,
  class: "bg-amber-50 border border-amber-200 rounded-lg p-3"
}
const _hoisted_15 = {
  key: 5,
  class: "bg-blue-50 border border-blue-200 rounded-lg p-4"
}
const _hoisted_16 = {
  key: 6,
  class: "bg-green-50 border border-green-200 rounded-lg p-4"
}
const _hoisted_17 = {
  key: 7,
  class: "bg-green-50 border border-green-200 rounded-lg p-4"
}
const _hoisted_18 = {
  key: 8,
  class: "space-y-3"
}
const _hoisted_19 = {
  key: 0,
  class: "p-4 bg-red-50 border border-red-300 rounded-lg"
}
const _hoisted_20 = { class: "list-disc list-inside space-y-1" }
const _hoisted_21 = { key: 9 }
const _hoisted_22 = {
  key: 0,
  class: "mb-3 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900"
}
const _hoisted_23 = {
  key: 10,
  class: "bg-red-50 border border-red-200 rounded-lg p-4"
}
const _hoisted_24 = {
  key: 0,
  class: "mt-6 flex justify-end gap-3"
}
const _hoisted_25 = {
  key: 0,
  class: "flex flex-col gap-2 mx-auto mb-4"
}
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-2"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = {
  key: 1,
  class: "flex flex-col gap-2"
}
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-2"
}
const _hoisted_33 = {
  key: 2,
  class: "flex flex-col gap-2"
}
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-2"
}
const _hoisted_36 = {
  key: 3,
  class: "flex flex-col gap-2"
}
const _hoisted_37 = ["disabled", "title"]
const _hoisted_38 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-2"
}
const _hoisted_39 = {
  key: 0,
  class: "text-xs text-red-600 text-center"
}
const _hoisted_40 = {
  key: 1,
  class: "text-xs text-red-600 text-center"
}
const _hoisted_41 = {
  key: 1,
  class: "mt-6 flex flex-col items-stretch gap-2"
}
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-2"
}
const _hoisted_44 = {
  key: 0,
  class: "text-xs text-red-600 text-center"
}
const _hoisted_45 = {
  key: 1,
  class: "text-xs text-red-600 text-center"
}

import { computed, inject, provide, ref, watch, type ComputedRef } from "vue";
import { ModalComp } from "@/components";
import ParcelDimensions from "@/components/order/ParcelDimensions.vue";
import UploadZone from "@/components/order/UploadZone.vue";
import {
  getLabelModule,
  isGpxCarrier as isGpxCarrierId,
} from "@/utils/labelModuleSelector";
import {
  getUploadedInvoices,
  getShippingDocument,
  saveParcelDimensions as persistParcelDimensions,
  acknowledgeUsCustomsNotice,
  updateStatus,
  OrderConfirmationCancelledError,
  generateLabelEasy,
} from "@/api/orders";
import { useNotification } from "@/composables/useNotification";
import { useCustomsDeclarationStore } from "@/stores/customsDeclaration";
import {
  getCarrierDimensionLimits,
  validateColisDimensions,
} from "@/utils/parcelDimensionsLimits";
import type { OrderDetailResponse } from "@/types";

interface Props {
  isVisible: boolean;
  orderId: number;
  orderStatus: number;
  idLivraison: number | null;
  countryCode?: string | null;
  postalCode?: string | null;
  carrierName?: string;
  orderDetailData?: OrderDetailResponse | null;
}

interface Emits {
  (e: "update:isVisible", value: boolean): void;
  (e: "labels-generated"): void;
  (e: "order-confirmed"): void;
  (e: "parcel-removed"): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LabelGenerationModal',
  props: {
    isVisible: { type: Boolean },
    orderId: {},
    orderStatus: {},
    idLivraison: {},
    countryCode: {},
    postalCode: {},
    carrierName: {},
    orderDetailData: {}
  },
  emits: ["update:isVisible", "labels-generated", "order-confirmed", "parcel-removed"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// Récupérer les données de la commande depuis le parent (comme ComputedRef pour la réactivité)
// Si orderDetailData est passé en prop, l'utiliser, sinon essayer inject
const orderDetailDataFromInject = inject<
  ComputedRef<{ value: OrderDetailResponse | null }>
>(
  "orderDetailData",
  computed(() => ({ value: null })),
);
const orderDetailData = computed(() => {
  // Priorité à la prop si elle existe
  if (props.orderDetailData) {
    return { value: props.orderDetailData };
  }
  // Sinon utiliser inject
  return orderDetailDataFromInject.value;
});

// Helper pour accéder facilement aux données de la commande
const orderData = computed(() => orderDetailData.value?.value);

// Fournir orderDetailData aux composants enfants (Label components)
provide(
  "orderDetailData",
  computed(() => ({ value: orderData.value })),
);

// Déterminer si c'est un groupage
const isGroupage = computed(() => {
  if (!orderData.value) return false;
  const groupageValue = orderData.value.commandeGroupe?.groupage;
  const isSingleGpxOrder =
    isGpxCarrierId(props.idLivraison) &&
    Number(orderData.value.groupageReadiness?.countTotal) === 1;
  const explicitGroupage =
    groupageValue === 1 ||
    String(groupageValue) === "1" ||
    orderData.value.groupage === true;
  const singleGpxShipsDirect =
    isSingleGpxOrder && orderData.value.outsideEuShippingZone !== true;
  return explicitGroupage && !singleGpxShipsDirect;
});

// Nombre de colis pour ParcelDimensions (utilisé uniquement pour les groupages)
// Priorité : dynamicNbColis (mis à jour par ParcelDimensions) > nb_colis depuis la commande
const nbColis = computed(() => {
  return dynamicNbColis.value ?? orderData.value?.nb_colis ?? 1;
});

// Nombre dynamique de colis (mis à jour par ParcelDimensions)
const dynamicNbColis = ref<number | null>(null);
const hasParcelRemoval = ref(false);
const usNoticeLanguage = ref<"fr" | "zh">("fr");
const usCustomsNoticeAccepted = ref(false);
const isAcceptingUsNotice = ref(false);

// Dimensions groupage valides (rempli par ParcelDimensions via @update:valid)
const groupageDimensionsValid = ref(false);

// Déterminer si on doit afficher ParcelDimensions
// Conditions de l'ancien système :
// - Pour les commandes groupage et les transporteurs propres de l'acheteur
// - statut != 3 (pas annulé)
// - idLivraison != 3 (pas Free Shipping)
const shouldShowParcelDimensions = computed(() => {
  // Groupage en confirmation : dimensions demandées plus tard (avant téléchargement)
  if (isGroupage.value && [1, 9].includes(Number(props.orderStatus))) {
    return false;
  }

  if (
    !isGroupage.value &&
    !isClientTransporter.value &&
    !labelModule.value
  )
    return false;

  // Vérifier les autres conditions
  if (Number(props.orderStatus) === 3) return false; // Commande annulée
  if (props.idLivraison === 3) return false; // Free Shipping

  return true;
});

// Erreurs de dimensions — calculées depuis le store Pinia (accès direct au state pour la réactivité)
const customsStore = useCustomsDeclarationStore();
const parcelDimensions = computed(() =>
  customsStore.getParcelDimensions(props.orderId),
);
const parcelWeights = computed(() =>
  parcelDimensions.value.map((dimension) => Number(dimension.poids) || 0),
);
const groupageDimensionErrors = computed<string[]>(() => {
  const list =
    customsStore.declarations[props.orderId]?.parcelDimensions?.dimensions;
  if (!list || list.length === 0) return [];
  const lim = getCarrierDimensionLimits(props.idLivraison, props.countryCode ?? props.orderDetailData?.adresseLivraison?.pays?.code, props.postalCode ?? props.orderDetailData?.adresseLivraison?.codePostal);
  const errors: string[] = [];
  list.forEach((colis, idx) => {
    const num = idx + 1;
    const l = colis.longueur;
    const w = colis.largeur;
    const h = colis.hauteur;
    const p = colis.poids;
    if (
      l == null ||
      l <= 0 ||
      w == null ||
      w <= 0 ||
      h == null ||
      h <= 0 ||
      p == null ||
      p <= 0
    )
      return;
    if (p > lim.poids)
      errors.push(
        `Colis n°${num} : ${p} kg saisis, maximum ${lim.poids} kg.`,
      );
    const msg = validateColisDimensions(l, w, h, lim);
    if (msg) {
      errors.push(`Colis n°${num} : ${msg}.`);
    }
  });
  return errors;
});

const hasCompleteGroupageDimensions = computed(() => {
  const list =
    customsStore.declarations[props.orderId]?.parcelDimensions?.dimensions;
  if (!list || list.length === 0) return false;

  return list.every((colis) => {
    const l = colis.longueur;
    const w = colis.largeur;
    const h = colis.hauteur;
    const p = colis.poids;
    return (
      l != null &&
      l > 0 &&
      w != null &&
      w > 0 &&
      h != null &&
      h > 0 &&
      p != null &&
      p > 0
    );
  });
});

const preloadedGroupageValid = computed(() => {
  return (
    hasCompleteGroupageDimensions.value &&
    groupageDimensionErrors.value.length === 0
  );
});

// Les envois hors groupage lisent cette valeur directement du store afin que
// le bouton de génération se mette à jour dès la dernière dimension saisie.
const parcelDimensionsValid = computed(
  () => preloadedGroupageValid.value,
);

// Déterminer le module d'étiquette à utiliser
const labelModule = computed(() => {
  return getLabelModule(props.idLivraison, false);
});

const requiresUsCustomsCompliance = computed(
  () => orderData.value?.requiresUsCustomsCompliance === true,
);
const requiresOutsideEuInvoice = computed(
  () => orderData.value?.outsideEuShippingZone === true,
);
const showCustomsInvoiceReminder = computed(
  () =>
    !requiresOutsideEuInvoice.value &&
    orderData.value?.needsCustomsDeclaration === true &&
    !requiresUsCustomsCompliance.value,
);
const canAccessUsShippingSteps = computed(
  () => !requiresUsCustomsCompliance.value || usCustomsNoticeAccepted.value,
);

const groupageReadyToConfirm = computed(
  () => canAccessUsShippingSteps.value,
);

const acceptUsNotice = async () => {
  if (!props.orderId || isAcceptingUsNotice.value) return;
  isAcceptingUsNotice.value = true;
  try {
    usCustomsNoticeAccepted.value = await acknowledgeUsCustomsNotice(props.orderId);
    success("Commande passée en groupage eFashion");
    emit("parcel-removed");
  } catch (error) {
    showError(error instanceof Error ? error.message : "Impossible d’enregistrer votre confirmation");
  } finally {
    isAcceptingUsNotice.value = false;
  }
};


// Liste des transporteurs standards gérés par eFashion (inclut UPS groupage, Colissimo, DPD, etc.)
const STANDARD_TRANSPORTERS = [
  "1",
  "4",
  "8",
  "12",
  "16",
  "18",
  "2736",
  "2737",
  "2924",
  "2925", // Colissimo
  "7",
  "17", // OCX
  "10",
  "13", // DPD
  "19", // UPS (normal et groupage)
  "6",
  "11",
  "2649",
  "2915", // GPX
  "14",
  "15",
  "2742",
  "2931", // GLS
  "2729",
  "2730",
  "2731",
  "2732",
  "2747",
  "2917",
  "2918",
  "2919",
  "2920",
  "2921",
  "2922", // Chronopost
  "2733",
  "2734",
  "2735",
  "2738",
  "2739", // DHL
  "2748",
  "2926",
  "2927",
  "2928",
  "2929",
  "2930", // Fedex
  "2743",
  "2744",
  "2745",
  "2923", // UPS Express Saver (Easy)
  "2932", // UPS Standard (Easy)
  "2746", // Easy Colissimo
  "2741", // OCX Africa
  "2916", // Bolloré
];

// Pour les groupages : ne jamais appeler l'API Easy ici (étiquettes générées côté eFashion ou par le transporteur).
const shouldGenerateLabelsOnConfirm = computed(() => {
  if (isGroupage.value) return false;
  return false;
});

// Détecter si c'est un transporteur propre du client (acheteur)
const isClientTransporter = computed(() => {
  const livraison = orderData.value?.livraison;
  if (livraison && "id_acheteur" in livraison) {
    return livraison.id_acheteur != null;
  }

  return (
    props.idLivraison &&
    !STANDARD_TRANSPORTERS.includes(String(props.idLivraison))
  );
});

const clientTransporterReadyToConfirm = computed(
  () =>
    canAccessUsShippingSteps.value &&
    hasUploadedInvoices.value &&
    groupageDimensionsValid.value,
);

// Titre du modal selon le transporteur
const modalTitle = computed(() => {
  if (props.carrierName) {
    return `Génération d'étiquettes - ${props.carrierName}`;
  }
  return "Génération d'étiquettes de colis";
});

// Gérer la génération réussie des étiquettes
const handleLabelsGenerated = () => {
  emit("labels-generated");
  emit("update:isVisible", false);
};

// Vérifier les factures pour les groupages
const hasUploadedInvoices = ref(false);
const orderGroupId = computed(() => {
  return orderData.value?.id_commande_groupe || 0;
});
const orderDate = computed(() => {
  return (
    orderData.value?.commandeGroupe?.date_creation || new Date().toISOString()
  );
});
const invoiceId = computed(() => {
  return orderData.value?.id_commande_name || undefined;
});

// Notifications
const { success, error: showError } = useNotification();

const canGenerateShippingLabels = computed(
  () =>
    parcelDimensionsValid.value &&
    hasUploadedInvoices.value &&
    ![1, 3, 9].includes(Number(props.orderStatus)),
);

const isPendingConfirmationStatus = computed(() =>
  [1, 9].includes(Number(props.orderStatus)),
);

const canShowShippingLabelGenerateFooter = computed(() => {
  if (isPendingConfirmationStatus.value) return false;
  if (isGroupage.value || isClientTransporter.value) return false;
  if (props.idLivraison === 2 || props.idLivraison === 3) return false;
  if (!labelModule.value || !canAccessUsShippingSteps.value) return false;
  return ["colissimo", "dpd", "ups", "easy"].includes(labelModule.value);
});

const isGeneratingLabels = ref(false);

const generateShippingLabelsFromModal = async () => {
  if (!canGenerateShippingLabels.value || isGeneratingLabels.value) return;
  if (!props.orderId || !labelModule.value) return;

  try {
    isGeneratingLabels.value = true;
    await customsStore.saveDimensionsToDB(props.orderId);

    const dimensions = customsStore.getParcelDimensions(props.orderId);
    const colisPoids = dimensions.map((dim) => Number(dim.poids) || 0);
    const response = await generateLabelEasy({
      id_commande: props.orderId,
      nbColis: dimensions.length || nbColis.value,
      colisPoids,
      parcelDimensions: dimensions,
    });

    if (response.success) {
      success("Étiquettes générées avec succès");
      handleLabelsGenerated();
    } else {
      showError(
        response.error || "Erreur lors de la génération des étiquettes",
      );
    }
  } catch (error) {
    showError(
      error instanceof Error
        ? error.message
        : "Erreur lors de la génération des étiquettes",
    );
  } finally {
    isGeneratingLabels.value = false;
  }
};

// Vérifier si on doit afficher la zone d'upload de facture
const shouldShowInvoiceUpload = computed(() => {
  // Hors UE : la facture est obligatoire dès la validation, même si la
  // commande vient d'être basculée en groupage.
  if (
    isGroupage.value &&
    [1, 9].includes(Number(props.orderStatus)) &&
    !requiresOutsideEuInvoice.value
  ) {
    return false;
  }
  // Afficher uniquement si aucune facture n'a été trouvée
  return !hasUploadedInvoices.value;
});

// Vérifier les factures au montage
const checkInvoices = async () => {
  if (!props.orderId) return;
  const [invoicesResult, shippingDocumentResult] = await Promise.allSettled([
    getUploadedInvoices(props.orderId),
    getShippingDocument(props.orderId),
  ]);
  hasUploadedInvoices.value =
    (invoicesResult.status === "fulfilled" &&
      invoicesResult.value.length > 0) ||
    (shippingDocumentResult.status === "fulfilled" &&
      shippingDocumentResult.value.exists);
};

const preloadParcelDimensions = () => {
  const raw = orderData.value?.data;
  if (!raw) return;

  let parsed: unknown = raw;
  if (typeof raw === "string") {
    try {
      parsed = JSON.parse(raw);
    } catch {
      return;
    }
  }

  const dimensions = (
    parsed as {
      infocolis?: {
        dimensioncolis?: Array<{
          longueur?: unknown;
          largeur?: unknown;
          hauteur?: unknown;
          poids?: unknown;
        }>;
      };
    }
  )?.infocolis?.dimensioncolis;

  if (!Array.isArray(dimensions) || dimensions.length === 0) return;

  const toNumberOrNull = (value: unknown): number | null => {
    const number = Number(value);
    return value !== "" && value != null && Number.isFinite(number)
      ? number
      : null;
  };

  customsStore.saveParcelDimensions(
    props.orderId,
    dimensions.map((dimension) => ({
      longueur: toNumberOrNull(dimension.longueur),
      largeur: toNumberOrNull(dimension.largeur),
      hauteur: toNumberOrNull(dimension.hauteur),
      poids: toNumberOrNull(dimension.poids),
    })),
  );
};

// Gérer l'upload d'une facture
const handleInvoiceUploaded = async () => {
  // Recharger les factures
  await checkInvoices();
  // Émettre un événement pour les composants enfants
  window.dispatchEvent(
    new CustomEvent("invoiceUploaded", { detail: { orderId: props.orderId } }),
  );
};

// Gérer le changement du nombre de colis depuis ParcelDimensions
const handleColisCountChanged = (newCount: number, removedIndex?: number) => {
  dynamicNbColis.value = newCount;
  if (removedIndex != null) hasParcelRemoval.value = true;
};

watch(
  () => props.isVisible,
  (visible) => {
    if (!visible && hasParcelRemoval.value) {
      hasParcelRemoval.value = false;
      emit("parcel-removed");
    }
  },
);

const isConfirming = ref(false);

// Confirmer la commande groupage (statut 7 ou 8 selon statut actuel)
const confirmGroupageOrder = async () => {
  if (!props.orderId) return;
  if (!groupageReadyToConfirm.value) {
    showError(
      "Veuillez d'abord lire et accepter les consignes d'expédition.",
    );
    return;
  }
  await performGroupageConfirmation();
};

const performGroupageConfirmation = async () => {
  if (!props.orderId) return;
  try {
    isConfirming.value = true;

    const newStatus = props.orderStatus === 9 ? 8 : 7;
    await updateStatus(props.orderId, newStatus);
    emit("order-confirmed");
    emit("update:isVisible", false);
    success("Commande groupage confirmée avec succès !");
    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (error) {
    if (error instanceof OrderConfirmationCancelledError) return;
    showError(
      error instanceof Error
        ? error.message
        : "Erreur lors de la confirmation du groupage",
    );
  } finally {
    isConfirming.value = false;
  }
};

const confirmClientTransporterOrder = async () => {
  if (!props.orderId) return;
  if (!clientTransporterReadyToConfirm.value) {
    showError(
      "La facture est obligatoire et tous les colis doivent respecter le gabarit indiqué.",
    );
    return;
  }
  if (groupageDimensionErrors.value.length > 0) {
    showError(
      "Un colis dépasse le gabarit autorisé. Répartissez son contenu dans deux colis ou plus.",
    );
    return;
  }
  await performClientTransporterConfirmation();
};

const performClientTransporterConfirmation = async () => {
  if (!props.orderId) return;
  try {
    isConfirming.value = true;
    const dimensions = customsStore.getParcelDimensions(props.orderId);
    await persistParcelDimensions(props.orderId, dimensions);

    // Pour les transporteurs acheteur, utiliser le même statut que OCX (7 = attente d'enlèvement)
    await updateStatus(props.orderId, 7);

    emit("order-confirmed");
    emit("update:isVisible", false);

    success("Commande confirmée avec succès !");

    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (error) {
    if (error instanceof OrderConfirmationCancelledError) return;
    showError(
      error instanceof Error
        ? error.message
        : "Erreur lors de la confirmation de la commande",
    );
  } finally {
    isConfirming.value = false;
  }
};

const confirmPickupOrder = async () => {
  if (!props.orderId) return;

  try {
    isConfirming.value = true;
    // Pour les retraits en magasin, passer directement au statut 4 (confirmée)
    await updateStatus(props.orderId, 4);

    emit("order-confirmed");
    emit("update:isVisible", false);

    success("Retrait en magasin confirmé avec succès !");

    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (error) {
    // Erreur silencieuse - la confirmation a échoué
  } finally {
    isConfirming.value = false;
  }
};

const confirmFreeShippingOrder = async () => {
  if (!props.orderId) return;

  try {
    isConfirming.value = true;
    // Pour les livraisons gratuites, passer directement au statut 4 (confirmée)
    await updateStatus(props.orderId, 4);

    emit("order-confirmed");
    emit("update:isVisible", false);

    success("Livraison offerte confirmée avec succès !");

    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (error) {
    // Erreur silencieuse - la confirmation a échoué
  } finally {
    isConfirming.value = false;
  }
};

// Vérifier les factures quand la modal devient visible ou quand orderData change
watch(
  [() => props.isVisible, () => orderData.value],
  async ([isVisible, data]) => {
    if (isVisible && data) {
      usCustomsNoticeAccepted.value =
        data.usCustomsNoticeAccepted === true;
      // Toujours vérifier les factures pour toutes les commandes
      await checkInvoices();
      preloadParcelDimensions();
      if (shouldShowParcelDimensions.value) {
        groupageDimensionsValid.value = preloadedGroupageValid.value;
      }
    }
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ModalComp), {
    isVisible: _ctx.isVisible,
    title: modalTitle.value,
    size: "xl",
    hideFooter: true,
    "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:isVisible', $event)))
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (requiresUsCustomsCompliance.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h5", _hoisted_4, [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-exclamation-triangle mr-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(usNoticeLanguage.value === "fr" ? "ATTENTION – EXPÉDITIONS VERS LES ÉTATS-UNIS" : "注意 – 发往美国的货件"), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["rounded px-2 py-1", usNoticeLanguage.value === 'fr' ? 'bg-red-600 text-white' : 'text-red-800']),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (usNoticeLanguage.value = 'fr'))
                  }, "Français", 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["rounded px-2 py-1", usNoticeLanguage.value === 'zh' ? 'bg-red-600 text-white' : 'text-red-800']),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (usNoticeLanguage.value = 'zh'))
                  }, "中文", 2)
                ])
              ]),
              (usNoticeLanguage.value === 'fr')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[5] || (_cache[5] = [
                    _createElementVNode("p", null, "Depuis le 8 juillet 2026, certaines marchandises expédiées vers les États-Unis doivent respecter de nouvelles obligations de conformité auprès de la CPSC, notamment via un GCC ou CPC selon le type de produit.", -1),
                    _createElementVNode("p", null, "Les vendeurs sont responsables des informations et documents transmis. En cas d’erreur, de document manquant ou de déclaration incorrecte, la marchandise peut être bloquée, retardée ou retournée par la douane américaine.", -1),
                    _createElementVNode("p", { class: "font-semibold" }, "Les éventuels frais supplémentaires liés à une déclaration incorrecte ou incomplète seront à la charge du vendeur.", -1),
                    _createElementVNode("p", null, [
                      _createTextVNode("Pour effectuer les démarches nécessaires : "),
                      _createElementVNode("a", {
                        class: "font-semibold underline",
                        href: "https://www.cpsc.gov/eFiling-CPSC-Product-Registry",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, "www.cpsc.gov/eFiling-CPSC-Product-Registry")
                    ], -1),
                    _createElementVNode("p", { class: "font-semibold" }, "La facture commerciale doit notamment comporter :", -1),
                    _createElementVNode("ul", { class: "list-disc space-y-1 pl-5" }, [
                      _createElementVNode("li", null, "Numéro et date de facture"),
                      _createElementVNode("li", null, "Numéro de commande"),
                      _createElementVNode("li", null, "Coordonnées complètes de l’expéditeur et du destinataire"),
                      _createElementVNode("li", null, "Références des articles : homme, femme ou enfant"),
                      _createElementVNode("li", null, "Quantité et prix unitaire"),
                      _createElementVNode("li", null, "Montant total et devise"),
                      _createElementVNode("li", null, "Description des marchandises en anglais"),
                      _createElementVNode("li", null, "Composition et type de fabrication : woven ou knitted"),
                      _createElementVNode("li", null, "Pays d’origine et informations du fabricant"),
                      _createElementVNode("li", null, "Code HS des produits")
                    ], -1),
                    _createElementVNode("p", { class: "font-semibold" }, "Merci de vérifier soigneusement ces informations avant toute expédition vers les États-Unis.", -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[6] || (_cache[6] = [
                    _createElementVNode("p", null, "自 2026 年 7 月 8 日起，部分发往美国的商品必须遵守美国消费品安全委员会（CPSC）的新合规要求。根据产品类型，可能需要提供 GCC（一般合格证书）或 CPC（儿童产品证书）。", -1),
                    _createElementVNode("p", null, "卖家须对所提交的信息和文件负责。如信息错误、文件缺失或申报不准确，货物可能被美国海关扣留、延误或退回。", -1),
                    _createElementVNode("p", { class: "font-semibold" }, "因申报错误或不完整而产生的额外费用将由卖家承担。", -1),
                    _createElementVNode("p", null, [
                      _createTextVNode("办理相关手续："),
                      _createElementVNode("a", {
                        class: "font-semibold underline",
                        href: "https://www.cpsc.gov/eFiling-CPSC-Product-Registry",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, "www.cpsc.gov/eFiling-CPSC-Product-Registry")
                    ], -1),
                    _createElementVNode("p", { class: "font-semibold" }, "商业发票至少应包含以下信息：", -1),
                    _createElementVNode("ul", { class: "list-disc space-y-1 pl-5" }, [
                      _createElementVNode("li", null, "发票编号和日期"),
                      _createElementVNode("li", null, "订单编号"),
                      _createElementVNode("li", null, "发件人和收件人的完整联系信息"),
                      _createElementVNode("li", null, "商品类别及货号：男装、女装或童装"),
                      _createElementVNode("li", null, "数量和单价"),
                      _createElementVNode("li", null, "总金额和币种"),
                      _createElementVNode("li", null, "英文商品描述"),
                      _createElementVNode("li", null, "面料成分及制作类型：梭织（woven）或针织（knitted）"),
                      _createElementVNode("li", null, "原产国及制造商信息"),
                      _createElementVNode("li", null, "商品 HS 编码")
                    ], -1),
                    _createElementVNode("p", { class: "font-semibold" }, "发往美国前，请务必仔细核对上述信息。", -1)
                  ]))),
              (!usCustomsNoticeAccepted.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "mt-5 rounded-md bg-red-700 px-5 py-2 font-semibold text-white hover:bg-red-800 disabled:bg-gray-400",
                    disabled: isAcceptingUsNotice.value,
                    onClick: acceptUsNotice
                  }, [
                    (isAcceptingUsNotice.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(usNoticeLanguage.value === "fr" ? "J’ai lu et j’ai compris" : "我已阅读并理解"), 1)
                  ], 8, _hoisted_8))
                : (_openBlock(), _createElementBlock("p", _hoisted_10, [
                    _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-check-circle mr-2" }, null, -1)),
                    _createTextVNode(_toDisplayString(usNoticeLanguage.value === "fr" ? "Consignes enregistrées : cette commande passe en groupage eFashion pour le pickup." : "说明已确认：此订单将转为 eFashion 集运并安排取件。"), 1)
                  ]))
            ]))
          : _createCommentVNode("", true),
        (showCustomsInvoiceReminder.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[8] || (_cache[8] = [
              _createElementVNode("h5", { class: "mb-2 text-sm font-bold text-amber-950" }, [
                _createElementVNode("i", { class: "fas fa-globe mr-2" }),
                _createTextVNode(" Destination soumise aux formalités douanières ")
              ], -1),
              _createElementVNode("p", { class: "text-sm text-amber-900" }, [
                _createTextVNode(" Vérifiez que votre facture indique "),
                _createElementVNode("strong", null, "l’origine de la marchandise"),
                _createTextVNode(" et une "),
                _createElementVNode("strong", null, "description des produits en anglais"),
                _createTextVNode(". ")
              ], -1)
            ])))
          : _createCommentVNode("", true),
        (shouldShowInvoiceUpload.value && canAccessUsShippingSteps.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("h5", _hoisted_13, [
                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-exclamation-triangle mr-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(requiresOutsideEuInvoice.value ? "Facture commerciale recommandée" : "Facture requise"), 1)
              ]),
              _createVNode(UploadZone, {
                "order-id": _ctx.orderId,
                "order-group-id": orderGroupId.value,
                "order-date": orderDate.value,
                "invoice-id": invoiceId.value,
                onInvoiceUploaded: handleInvoiceUploaded
              }, null, 8, ["order-id", "order-group-id", "order-date", "invoice-id"])
            ]))
          : _createCommentVNode("", true),
        (shouldShowParcelDimensions.value)
          ? (_openBlock(), _createBlock(ParcelDimensions, {
              key: 3,
              "order-id": _ctx.orderId,
              "order-status": _ctx.orderStatus,
              "nb-colis": nbColis.value || 1,
              "calculated-weight": orderData.value?.poids,
              "id-livraison": _ctx.idLivraison,
              "country-code": _ctx.countryCode ?? orderDetailData.value?.adresseLivraison?.pays?.code,
              "postal-code": _ctx.postalCode ?? orderDetailData.value?.adresseLivraison?.codePostal,
              title: 
            !isGroupage.value
              ? 'Préparation de l’expédition'
              : undefined
          ,
              onColisCountChanged: handleColisCountChanged,
              "onUpdate:valid": _cache[2] || (_cache[2] = ($event: any) => (groupageDimensionsValid.value = $event))
            }, null, 8, ["order-id", "order-status", "nb-colis", "calculated-weight", "id-livraison", "country-code", "postal-code", "title"]))
          : _createCommentVNode("", true),
        (shouldShowParcelDimensions.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[10] || (_cache[10] = [
              _createElementVNode("p", { class: "text-sm text-amber-900" }, [
                _createElementVNode("i", { class: "fas fa-exclamation-triangle mr-2" }),
                _createElementVNode("strong", null, "Attention :"),
                _createTextVNode(" En cas de contrôle transporteur, si les dimensions ou le poids renseignés ne correspondent pas aux valeurs réelles et qu’une surfacturation nous est appliquée, celle-ci sera à votre charge. ")
              ], -1)
            ])))
          : _createCommentVNode("", true),
        (props.idLivraison === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[11] || (_cache[11] = [
              _createElementVNode("p", { class: "text-sm text-blue-800" }, [
                _createElementVNode("i", { class: "fas fa-store mr-2" }),
                _createElementVNode("strong", null, "Retrait en magasin"),
                _createElementVNode("br"),
                _createTextVNode(" Le client viendra retirer sa commande directement dans vos locaux. Aucune étiquette ni expédition n'est nécessaire. ")
              ], -1)
            ])))
          : (props.idLivraison === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[12] || (_cache[12] = [
                _createElementVNode("p", { class: "text-sm text-green-800" }, [
                  _createElementVNode("i", { class: "fas fa-gift mr-2" }),
                  _createElementVNode("strong", null, "Livraison offerte par eFashion"),
                  _createElementVNode("br"),
                  _createTextVNode(" Cette commande bénéficie d'une livraison gratuite offerte par eFashion Paris. Aucune action supplémentaire n'est requise de votre part. ")
                ], -1)
              ])))
            : (isClientTransporter.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[13] || (_cache[13] = [
                  _createElementVNode("p", { class: "text-sm text-green-800" }, [
                    _createElementVNode("i", { class: "fas fa-truck mr-2" }),
                    _createElementVNode("strong", null, "Transporteur acheteur"),
                    _createElementVNode("br"),
                    _createTextVNode(" Cette commande utilise un transporteur sélectionné par l'acheteur. Les étiquettes doivent être générées manuellement ou par le transporteur lui-même. ")
                  ], -1)
                ])))
              : (isGroupage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (groupageDimensionErrors.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-sm font-semibold text-red-900 mb-2" }, [
                            _createElementVNode("i", { class: "fas fa-exclamation-triangle mr-2" }),
                            _createTextVNode(" Gabarit dépassé — répartissez le contenu dans deux colis ou plus : ")
                          ], -1)),
                          _createElementVNode("ul", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupageDimensionErrors.value, (err, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: i,
                                class: "text-sm text-red-800"
                              }, _toDisplayString(err), 1))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (labelModule.value && canAccessUsShippingSteps.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (hasUploadedInvoices.value && !parcelDimensionsValid.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[15] || (_cache[15] = [
                            _createElementVNode("i", { class: "fas fa-info-circle mr-1" }, null, -1),
                            _createTextVNode(" Renseignez les dimensions et le poids de tous les colis pour générer les étiquettes. ")
                          ])))
                        : _createCommentVNode("", true)
                    ]))
                  : (canAccessUsShippingSteps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[16] || (_cache[16] = [
                        _createElementVNode("p", { class: "text-sm text-red-800" }, [
                          _createElementVNode("i", { class: "fas fa-exclamation-circle mr-2" }),
                          _createTextVNode(" Aucun transporteur n'a été défini pour cette commande. ")
                        ], -1)
                      ])))
                    : _createCommentVNode("", true)
      ]),
      (isPendingConfirmationStatus.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            (isGroupage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("button", {
                    onClick: confirmGroupageOrder,
                    class: _normalizeClass(["px-6 py-3 text-base font-semibold rounded-lg transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed", 
              groupageReadyToConfirm.value
                ? 'bg-green-600 text-white hover:bg-green-700'
                : 'bg-gray-400 text-black cursor-not-allowed'
            ]),
                    type: "button",
                    disabled: !groupageReadyToConfirm.value || isConfirming.value
                  }, [
                    (isConfirming.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                      : _createCommentVNode("", true),
                    (isConfirming.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString("Confirmation...")))
                      : (_openBlock(), _createElementBlock("span", _hoisted_29, " Confirmer "))
                  ], 10, _hoisted_26)
                ]))
              : (props.idLivraison === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("button", {
                      onClick: confirmPickupOrder,
                      class: "px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed",
                      type: "button",
                      disabled: isConfirming.value
                    }, [
                      (isConfirming.value)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_32))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(isConfirming.value ? "Confirmation..." : "Confirmer la commande"), 1)
                    ], 8, _hoisted_31)
                  ]))
                : (props.idLivraison === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("button", {
                        onClick: confirmFreeShippingOrder,
                        class: "px-4 py-2 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed",
                        type: "button",
                        disabled: isConfirming.value
                      }, [
                        (isConfirming.value)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_35))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(isConfirming.value ? "Confirmation..." : "Confirmer la commande"), 1)
                      ], 8, _hoisted_34)
                    ]))
                  : (isClientTransporter.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("button", {
                          onClick: confirmClientTransporterOrder,
                          class: _normalizeClass(["px-4 py-2 text-sm rounded-lg transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed", 
              clientTransporterReadyToConfirm.value
                ? 'bg-green-600 text-white hover:bg-green-700'
                : 'bg-gray-400 text-black cursor-not-allowed'
            ]),
                          type: "button",
                          disabled: !clientTransporterReadyToConfirm.value || isConfirming.value,
                          title: 
              !hasUploadedInvoices.value
                ? 'Veuillez d\'abord uploader une facture'
                : !groupageDimensionsValid.value
                  ? 'Veuillez renseigner des colis conformes au gabarit indiqué'
                : ''
            
                        }, [
                          (isConfirming.value)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_38))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(isConfirming.value ? "Confirmation..." : "Confirmer la commande"), 1)
                        ], 10, _hoisted_37),
                        (!hasUploadedInvoices.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, _cache[17] || (_cache[17] = [
                              _createElementVNode("i", { class: "fas fa-exclamation-triangle mr-1" }, null, -1),
                              _createTextVNode(" Veuillez d'abord uploader une facture ")
                            ])))
                          : _createCommentVNode("", true),
                        (!groupageDimensionsValid.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, _cache[18] || (_cache[18] = [
                              _createElementVNode("i", { class: "fas fa-exclamation-triangle mr-1" }, null, -1),
                              _createTextVNode(" Renseignez tous les colis et respectez le gabarit indiqué ")
                            ])))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
          ]))
        : (canShowShippingLabelGenerateFooter.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["w-full px-6 py-3 text-base font-semibold rounded-lg transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed", 
            canGenerateShippingLabels.value
              ? 'bg-indigo-600 text-white hover:bg-indigo-700'
              : 'bg-gray-400 text-black cursor-not-allowed'
          ]),
                disabled: !canGenerateShippingLabels.value || isGeneratingLabels.value,
                onClick: generateShippingLabelsFromModal
              }, [
                (isGeneratingLabels.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_43))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(isGeneratingLabels.value
              ? "Génération en cours..."
              : "Générer vos étiquettes"), 1)
              ], 10, _hoisted_42),
              (!hasUploadedInvoices.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_44, _cache[19] || (_cache[19] = [
                    _createElementVNode("i", { class: "fas fa-exclamation-triangle mr-1" }, null, -1),
                    _createTextVNode(" Veuillez d'abord uploader une facture ")
                  ])))
                : (!parcelDimensionsValid.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_45, _cache[20] || (_cache[20] = [
                      _createElementVNode("i", { class: "fas fa-exclamation-triangle mr-1" }, null, -1),
                      _createTextVNode(" Renseignez les dimensions et le poids de tous les colis ")
                    ])))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["isVisible", "title"]))
}
}

})